import React, { useState } from "react";
import "./keyStrength.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { greyRightArrow, whiteRightArrow } from "../../source";
import { useWindowSize } from "react-use";

const KeyStrength = ({ bgImg, keyData }) => {
  const { width } = useWindowSize();
  const [isClicked, setIsClicked] = useState("right");

  return (
    <>
      <div className="key_strength_container">
        <img
          src={bgImg}
          alt="background"
          width={1640}
          height={883}
          className="bg_img"
        />
        <div className="key_strength_slider">
          <Swiper
            modules={[Autoplay, Navigation]}
            slidesPerView={1}
            spaceBetween={0}
            loop={true}
            // grabCursor={true}
            navigation={{
              nextEl: ".service_right_arrow",
              prevEl: ".service_left_arrow",
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            speed={width > 767 ? 3000 : 500}
          >
            {keyData.map((item, i) => (
              <SwiperSlide key={`key-strength-${i}`}>
                <div className="content_box" data-aos="fade-up">
                  <div className="img_wrapper">
                    <img
                      src={width <= 767 && item.imgMb ? item.imgMb : item.img}
                      alt={item.title}
                      width={width > 767 ? 981 : 343}
                      height={width > 767 ? 746 : 343}
                      className="container_img"
                    />
                    {width <= 767 && (
                      <h3
                        className="section_title48"
                        dangerouslySetInnerHTML={{ __html: item.title }}
                        data-aos="fade-up"
                      ></h3>
                    )}
                  </div>
                  <div className="content_wrapper" data-aos="fade-up">
                    {width > 767 && (
                      <h3
                        className="section_title48"
                        dangerouslySetInnerHTML={{ __html: item.title }}
                      ></h3>
                    )}
                    <p
                      className="section_desc"
                      dangerouslySetInnerHTML={{ __html: item.desc }}
                    ></p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          {/* {width <= 767 && ( */}
          <div className="arrow_container" data-aos="fade-up">
            <div
              className={`arrow_wrapper service_left_arrow ${
                isClicked === "left" ? "active" : ""
              }`}
              onClick={() => setIsClicked("left")}
            >
              <img
                src={
                  width > 767
                    ? whiteRightArrow
                    : isClicked === "left"
                    ? whiteRightArrow
                    : greyRightArrow
                }
                alt="left arrow"
                className="left_arrow"
              />
            </div>
            <div
              className={`arrow_wrapper service_right_arrow ${
                isClicked === "right" ? "active" : ""
              }`}
              onClick={() => setIsClicked("right")}
            >
              <img
                src={
                  width > 767
                    ? whiteRightArrow
                    : isClicked === "right"
                    ? whiteRightArrow
                    : greyRightArrow
                }
                alt="right arrow"
                className="right_arrow"
              />
            </div>
          </div>
          {/* )} */}
        </div>
      </div>
    </>
  );
};

export default KeyStrength;
